import { Component, Fragment, h, Prop } from '@stencil/core';
import { Article } from './interfaces';
import { closeCart, openDetails } from '../../../redux/actions';
import { store } from '../../../redux/store';
import { t } from '../../../redux/utils';
import { PriceCalculation, ShortPrice, TotalPriceCalculation } from '../../../types/types';

@Component({
  tag: 'rentware-cart-article',
  styleUrl: 'style.sass',
  shadow: true,
})
export class RentwareCartArticle {
  @Prop() article: Article;
  @Prop() showMileageModalForId: string = '';
  @Prop() isWaiting: boolean = false;
  @Prop() onShowVariationModalForId;
  @Prop() cartPriceCalculation: TotalPriceCalculation;

  openDetails!: typeof openDetails;
  closeCart!: typeof closeCart;

  componentWillLoad() {
    store.mapDispatchToProps(this, {
      openDetails,
      closeCart,
    });
  }

  handleOpenDetails = () => {
    this.closeCart();
    this.openDetails(this.article.key);
  };

  render() {
    const  price: ShortPrice = {
      gross: this.article.price.gross,
      net: this.article.price.net,
      priceCalculation: this.article.priceCalculationType,
    }

    const  totalPrice: ShortPrice = {
      gross: this.article.totalPrice.gross,
      net: this.article.totalPrice.net,
      priceCalculation: PriceCalculation.Interval,
    }

    const showTotalPrice = totalPrice.gross !== price.gross && this.cartPriceCalculation === TotalPriceCalculation.Interval

    return (
      <div class="AnimationContainer">
        <rentware-spacer size="S" />
        <div class="ArticleContainer">
          <div class="LeftContainer">
            {(this.article.isMileageOption && (
              <Fragment>
                <svg class="ImageIcon ImageIconMileage" width="30" height="31" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="0.5" y="0.879395" width="19" height="19" rx="9.5" />
                  <path d="M6 11.3794L8 13.3794L14 7.37939" stroke-line-cap="round" stroke-line-join="round" />
                </svg>
                <div class="ArticleInfo">
                  <span class="title">{this.article.articleTitle}</span>
                  <span>{this.article.articleText}</span>
                </div>
              </Fragment>
            )) || (
              <Fragment>
                <rentware-image className="ImageIcon Pointer" src={this.article.imgSrc} autoSize={true} onClick={this.handleOpenDetails} />

                <div class="ArticleInfo" onClick={this.handleOpenDetails}>
                  <span class="title">{this.article.articleTitle}</span>

                  <span>{this.article.articleText}</span>

                  {this.article.includedArticles?.length > 0 &&
                    this.article.includedArticles.map(item => {
                      return (
                        <span>
                          {item.title} x {item.amount}
                        </span>
                      );
                    })}
                </div>
              </Fragment>
            )}
          </div>

          <div class="RightContainer">
            {!this.article.isDeposit &&
            <div>
              <div>
                {this.article.itemAmount}x&nbsp;
                <rentware-item-price price={price} />
              </div>
              {showTotalPrice &&
              <div>
                <rtr-cart-item-total-price price={totalPrice} />
              </div>
              }
            </div>
            }

            {this.article.isMileageOption && this.showMileageModalForId !== this.article.itemId && (
              <div
                class="MileageEdit"
                onClick={e => {
                  e.preventDefault();
                  this.article.onEdit();
                }}
              >
                {t('cart.change')}
              </div>
            )}

            {this.article.removable &&
              ((!this.article.isVariation && (
                <rentware-amount-control
                  controlValues={{
                    disabled: this.isWaiting,
                    minAmount: this.article.minAmount,
                    maxAmount: this.article.maxAmount,
                    itemAmount: this.article.itemAmount,
                    isVariation: this.article.isVariation,
                    changeAmountCallback: this.article.changeAmountCallback,
                    deleteArticleCallback: this.article.deleteArticleCallback,
                  }}
                />
              )) || (
                <Fragment>
                  <rentware-amount-control
                    controlValues={{
                      disabled: this.isWaiting,
                      minAmount: this.article.minAmount,
                      maxAmount: this.article.maxAmount,
                      itemAmount: this.article.itemAmount,
                      isVariation: this.article.isVariation,
                      changeAmountCallback: () => this.onShowVariationModalForId(this.article.itemId),
                      deleteArticleCallback: this.article.deleteArticleCallback,
                    }}
                  />
                </Fragment>
              ))}
          </div>
        </div>
      </div>
    );
  }
}
